import { render, staticRenderFns } from "./confirm-delete-categ.vue?vue&type=template&id=4e8041ae&scoped=true"
import script from "./confirm-delete-categ.vue?vue&type=script&lang=js"
export * from "./confirm-delete-categ.vue?vue&type=script&lang=js"
import style0 from "./confirm-delete-categ.vue?vue&type=style&index=0&id=4e8041ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8041ae",
  null
  
)

export default component.exports